<template>
  <div>
    <el-dialog
      title="导入发货明细"
      :visible.sync="dialogVisible"
      width="1000px"
      top="15px"
      @close="close"
    >
      <el-button type="primary" @click="downLoadModel">
        下载导入模板
      </el-button>
      <el-upload
        action=""
        multiple
        :show-file-list="false"
        :http-request="uploadaction"
        style="display: inline-block;margin: 0 10px"
      >
        <el-button type="primary">
          选择文件上传
        </el-button>
      </el-upload>
      <h3 style="margin-top:10px;margin-bottom:10px">
        错误信息
      </h3>
      <el-table :data="errData" border style="width: 100%">
        <el-table-column prop="contractNum" label="合同号" align="left" fixed="left" width="150" />
        <el-table-column prop="errorMsg" label="错误提示" align="left">
          <template v-slot="{row}">
            <span style="color:red">{{ row.errorMsg }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div v-loading="tableLoading" class="tableBody" style="margin-top:10px">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column type="index" label="序号" fixed="left" align="left" width="50">
            <template v-slot="{row,$index}">
              {{ $index+1 }}
            </template>
          </el-table-column>
          <el-table-column prop="contractNum" label="合同号" align="left" />
          <el-table-column prop="shipmentNum" label="发货单号" align="left" />
          <el-table-column prop="shipmentDate" label="发货日期" align="left" />
          <el-table-column prop="logisticsNum" label="物流单号" align="left" />
          <el-table-column prop="logisticsCompany" label="物流公司" align="left" />
          <el-table-column prop="fromCity" label="起运地" align="left" />
          <el-table-column prop="toCity" label="到达地" align="left" />
          <el-table-column prop="productName" label="产品名称" align="left" />
          <el-table-column prop="serialNumber" label="产品序列号" align="left" />
        </el-table>
      </div>
      <div style="margin:10px 0">
        本次发货数量合计:{{ tableData.length }}
      </div>
      <div class="footer-btn">
        <el-button type="default" @click="calcel">
          取消导入
        </el-button>
        <el-button type="primary" :loading="loading" @click="sureImport">
          确定导入
        </el-button>
      </div>
      <a ref="downTag" :href="downURL" target="_blank" />
    </el-dialog>
  </div>
</template>

<script>
import { checkShippingData, saveShippingData, downShippingTemplate } from '@/API';
export default {
  data () {
    return {
      dialogVisible: this.dialogFormVisible,
      tableLoading: false,
      tableData: [],
      errData: [],
      downURL: '',
      loading: false
    };
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  methods: {
    close () {
      this.dialogVisible = false;
      this.tableData = [];
      this.errData = [];
    },
    calcel () {
      this.close();
    },
    sureImport () {
      // 导入
      this.loading = true;
      saveShippingData(this.tableData).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.dialogVisible = false;
          this.$message.success('导入成功');
        } else {
          // this.errData = json.data;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    // 下载
    downLoadModel () {
      downShippingTemplate().then((res) => {
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileName = '分配模板' + new Date().toLocaleString() + '.xlsx';
        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch(() => {});
    },
    // 文件上传
    uploadaction (upload) {
      const form = new FormData(); // 创建form对象
      form.append('file', upload.file);
      checkShippingData(form).then((res) => {
        let json = res;
        if (json.status === 200) {
          this.tableData = json.data.data.shippingSpecialCloudDetails;
          this.errData = json.data.data.shippingErrorDataVOS;
          // 设置分配金额
        } else {
          this.tableData = [];
        }
      }).catch(() => {

      });
    }

  },
  watch: {
    dialogFormVisible (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-status-dialog', val);
    }
  },
  mounted () {

  }

};
</script>

<style scoped>
.footer-btn{
  display: flex;
  justify-content: flex-end;
}
</style>
